module.exports = __webpack_public_path__ + "images/FUSA_icons/065-coupon.afd7f3c1cc6b6dfed7e57b607c206a08.svg";